/**
 * Transforms comma-separated values to pipe-separated values for backend processing
 * @param value - The input string with comma-separated values
 * @returns The transformed string with pipe-separated values
 */
export const transformCommasToPipes = (value: string): string => {
  if (!value) return value;

  // Split by comma, trim whitespace, and join with pipe
  return value
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length > 0) // Remove empty strings
    .join('|');
};
